(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("image", ["React"], factory);
	else if(typeof exports === 'object')
		exports["image"] = factory(require("React"));
	else
		root["image"] = factory(root["React"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__883__) => {
return 